import React from 'react';
import {Link} from 'react-router-dom'

const e = React.createElement;


  function Recover() {}
  Recover.prototype = Object.create(React.Component.prototype);


  Recover.prototype.render = function() {
  var tr_email = "E-mail";
  var tr_request = "herstel aanvragen";
  var tr_back = "Terug naar inloggen";

  if(this.props.language === "EN") {
    tr_email = "Email";
    tr_request = "request recovery";
    tr_back = "Back to login";
  }

    return e('div', null, [
      e('form', {key:"1", onSubmit:this.props.handleRecover}, [
        e('div', {key:"11"}, e('input', {type:"text", value:this.props.email, onChange:this.props.handleChange.bind(this, "email"), placeholder:tr_email, autoFocus:true})),
        e('div', {key:"12"}, e('input', {type:"submit", value:tr_request, disabled:this.props.recover_is_fetching})),
      ]),
      e('div', {key:"2", className:"footnote"}, e(Link, {to:"/", onClick:this.props.switchContent.bind(this, "login")}, tr_back)),
    ]);
  }


export default Recover



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/ModalAccount_Recover.js
// module id = 232
// module chunks = 0